// apis
import { searchByImage } from 'shared/api/imageSearch';

// store
import {
  SET_IMAGE_SEARCH_DATA,
  SET_IMAGE_SEARCH_FETCHING,
  SET_IMAGE_SEARCH_ERROR,
} from './actions';

// logging
import logger from 'shared/logger';

// defs
interface IFetchImageSearchData {
  base64Image: string;
  limit?: string;
  page?: string;
  version?: string;
  format?: string;
}

export const getImageSearchData = ({
  base64Image,
  limit = '10',
  page = '1',
  version = 'v1',
  format = 'png',
}: IFetchImageSearchData) => {
  return async (dispatch: any): Promise<any> => {
    const cleanedBase64Image = base64Image.replace(/^data:image\/(png|jpeg|jpg);base64,/, '');

    dispatch({ type: SET_IMAGE_SEARCH_FETCHING, payload: true });
    try {
      // Call the API with all required arguments
      const products = await searchByImage(cleanedBase64Image, limit, page, version, format);

      if (page === '1') {
        dispatch({
          type: SET_IMAGE_SEARCH_DATA,
          payload: products,
        });
      }

      return products;
    } catch (error: any) {
      logger.error({
        ERROR: 'IMAGE SEARCH DATA FETCH FAILED',
        MESSAGE: 'fetch image search data failed',
        METHOD_NAME: 'getImageSearchData',
        INFO: { error },
      });

      dispatch({ type: SET_IMAGE_SEARCH_ERROR, payload: error.message });
      return Promise.reject(error);
    } finally {
      dispatch({ type: SET_IMAGE_SEARCH_FETCHING, payload: false });
    }
  };
};
